// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface ShopByCategoryStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    container?: GridContainerProps;
    categoryGridItem?: GridItemProps;
    TitleText?: TypographyPresentationProps;
    categoryImage?: LazyImageProps;
    categoryLink?: LinkPresentationProps;
    categoryText?: TypographyPresentationProps;
    categoryTextWrapper?: InjectableCss;
}

export const shopByCategoryStyles: ShopByCategoryStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    container: {
        css: css`
            width: calc(100% - 30px)
        `,
    },
    categoryGridItem: {
        width: [6, 6, 4, 3, 2.4] as any,
    },
    TitleText: {
        variant: "h3",
        css: css`
            text-align: center;
            margin-top: 54px;
        `,
    },
    categoryImage: {
        width: "100%",
        height: "190px",
        css: css`
            img {
                max-height: 100%;
                height: 100%;
            }
        `,
    },
    categoryLink: {
        css: css`
            position: relative;
            height: 190px;
            width: 100%;
            display: block;

            > span {
                height: 190px;
                width: 100%;
                display: block;
            }
        `,
    },
    categoryText: {
        color: "primary.contrast",
        variant: "p",
        css: css`
            margin: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 18px;
            font-weight: bold;
        `,
    },
    categoryTextWrapper: {
        css: css`
            position: absolute;
            bottom: 0;
            padding: 15px;
            background-color: ${getColor("text.main")};
            opacity: 0.8;
            margin: 0;
            width: 100%;
        `,
    },
};
